import styled from "styled-components"
import { hideVisually } from "polished"

const SrOnly = styled.div(hideVisually)

export default SrOnly
